/// <amd-module name="Wiki/Overview/Components/WikiPageTree" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { isFolderAssociatedPage } from "Wiki/Overview/Utils/WikiHelper";
import { WikiPageMenuItemsProvider } from "Wiki/Overview/WikiPageMenuItemsProvider";
import { TreeMoreColumn } from "Wiki/PageTree/Components/TreeMoreColumn";
import * as WikiTreeInternal from "Wiki/PageTree/Components/WikiTree";
import { FilterTreeStore } from "Wiki/PageTree/Stores/FilterTreeStore";
import { WikiPageTreeItemProvider } from "Wiki/PageTree/WikiPageTreeItemProvider";
import { WikiInfo } from "Wiki/ViewCommon/Contracts";
import { isIncludeEditingAllowed } from "Wiki/ViewCommon/Utils/WikiHelper";

export interface IWikiPageTreeProps {
    menuItemProvider: WikiPageMenuItemsProvider;

    itemProvider: WikiPageTreeItemProvider;
    onPageSelected: (newPage: WikiPage) => void;
    onPageToggled: (page: WikiPage, isExpanded: boolean) => void;
    homePagePath: string | undefined;
    onFilteredPageSelected: (newPage: WikiPage) => void;
    onFilterChanged: (filterText: string) => void;
    onFilteringComplete: () => void;
    filterStore: FilterTreeStore;
    isReorderInProgress: boolean;
    selectedPagePath?: string;
    openInNewTab: (path: string) => void;
    wikiTreeDragDropProps: WikiTreeInternal.WikiTreeDragDropProps;

    isHandleBrokenLinksEnabled: boolean;
    wikiInfo: WikiInfo;
}

export interface IWikiPageTreeState {
    isLoading?: boolean;
    isFiltering?: boolean;
}

export class WikiPageTree extends VssComponent<IWikiPageTreeProps, IWikiPageTreeState> {
    private _isIncludeEditingAllowed: boolean;

    constructor(props: IWikiPageTreeProps, context: IVssComponentContext) {
        super(props, context);
        this.state = {};
        this._isIncludeEditingAllowed = isIncludeEditingAllowed(this.context.pageContext);
    }

    public componentDidMount(): void {
        super.componentDidMount();
        this.props.filterStore.addChangedListener(this._updateStateFromStore);
    }

    public render(): JSX.Element {
        const filterState = this.props.filterStore.getState();
        return (
            <WikiTreeInternal.WikiTree
                {...this.props}
                filterTreeItemProvider={filterState.treeItemProvider}
                isFilterLoading={filterState.isFilterLoading}
                isFiltering={filterState.isFiltering}
                additionalColumns={[new TreeMoreColumn(this.props.menuItemProvider.getTreeMenuItems, this._isCommandAvailable)]}
                isIncludeEditingAllowed={this._isIncludeEditingAllowed}
                wikiName={this.props.wikiInfo.wiki.name}
            />
        );
    }

    private _updateStateFromStore = (): void => {
        const newIsLoading = this.props.filterStore.getState().isFilterLoading;
        const newIsFiltering = this.props.filterStore.getState().isFiltering;
        if (newIsLoading != this.state.isLoading || newIsFiltering != this.state.isFiltering) {
            this.setState({
                isLoading: newIsLoading,
                isFiltering: newIsFiltering
            });
        }
    };

    private _isCommandAvailable(page: WikiPage): boolean {
        return !page.isNonConformant && !isFolderAssociatedPage(page);
    }
}
